import { AssetTransaction } from "./asset_transaction";

export class CryptoTransaction extends AssetTransaction {
	private confirmations: number = -1;
	private related_wallet_transaction_id: string = "";

	public hasAction(cancel: boolean = false): boolean {
		return (
			!this.isConfirmed() && this.isWithdrawal() && (this.isStatus("pending") || this.isStatus("open_invitation"))
		);
	}

	public isCancelable(): boolean {
		return this.isWithdrawal() && (this.isStatus("pending") || this.isStatus("open_invitation"));
	}

	public get displayRecipient(): string {
		return this.destination_tag === "" ? this.getRecipient() : `${this.getRecipient()} / ${this.destination_tag}`;
	}
}
